import BlogCard from '../BlogCard'
import BlogPagination from '../BlogPagination'
import EmptyState from '../EmptyState'
import { CardContainer, PaginationContainer } from '../styled'
import { IPostsComponent } from './types'

const Posts = ({ posts, page, setPage, totalPages }: IPostsComponent) => {
  if (!posts?.results) {
    return null
  }
  if (posts.results.length > 0) {
    return (
      <>
        {posts.results.map((blog, index) => (
          <CardContainer featured={index === 0} key={blog.id}>
            <BlogCard post={blog} featured={index === 0} />
          </CardContainer>
        ))}
        {totalPages > 1 && (
          <PaginationContainer>
            <BlogPagination page={page} setPage={setPage} totalPages={totalPages} />
          </PaginationContainer>
        )}
      </>
    )
  }
  return <EmptyState />
}

export default Posts
